<!--
 * @Author: 金小瑞
 * @Date: 2018-07-24 08:51:44
 * @LastEditors: kai.yang
 * @LastEditTime: 2020-06-05 19:32:10
 -->
<template>
  <div id="app">
    <div class="saas-pro-hint" v-if="isShowSaasPro">
      <p class="saas-pro-hint-text">
        <i class="el-icon-warning"></i>
      当前系统数据已经迁移到新系统（请在新系统内完整使用产品），新增数据不会同步到新系统，请勿新增！
      </p>
      <i class="el-icon-close" @click="isShowSaasPro = false"></i>
    </div>
    <commonheader @getMessageList="showMessageList=true"></commonheader>
    <sidemenu :class="{'side-menu-class': isShowSaasPro}"></sidemenu>
    <router-view :key="key"></router-view>
    <dycti v-if="moduleType" :xbbCallstatus="xbbCallstatus"></dycti>
    <transition name="slide">
        <message-list ref="messageList" v-if="showMessageList" @closeMessge="showMessageList=false" @openDeleteBox="openDeleteBox"></message-list>
    </transition>
    <delete-message ref="delete" @submitDelete="submitDelete"></delete-message>
  </div>
</template>

<script>
  import * as api from 'src/api'
  import { LS } from 'assets/js/storage'
  import { mapActions } from 'vuex'
  import commonheader from 'components/common/common-head'
  import sidemenu from 'components/common/side-menu'
  import messageList from 'components/common/message-list'
  import deleteMessage from 'components/modal/message/delete-message'
  // import 'src/config/web-socket.js'

  export default {
    name: 'app',

    data () {
      return {
        moduleType: 0,
        key: '', // 切换路由时，强制刷新组件
        showMessageList: false,
        isShowSaasPro: false,
        // 销帮帮呼叫中心套餐状态
        xbbCallstatus: ''
      }
    },

    computed: {
      // 子路由
      routeChild () {
        return this.$route.path.split('/').pop()
      }
    },

    created () {
      this.getIsShowSaasPro()
      this.getAliasList()
      const url = '/callcenter/module.do'
      api.post(url, {}, (data) => {
        this.moduleType = data.result.moduleType
        // 销帮帮呼叫中心套餐状态
        this.xbbCallstatus = data.result.status
        LS.set('VUE-CTI-moduleType', data.result.moduleType || 0)

        this.setModuleTypeList(data.result.moduleTypeList)
      })
    },

    methods: {
      ...mapActions([
        'setAliasList',
        'setModuleTypeList'
      ]),
      getIsShowSaasPro () {
        let url = `/user/isMovePro.html`
        api.post(url, {}, (data) => {
          this.isShowSaasPro = data.isMovePro
        })
      },
      getAliasList () {
        let url = `/businessAliasApi/getAliasList.html`
        api.post(url, {}, (data) => {
          let obj = {}
          for (let i = 0; i < data.result.length; i++) {
            let alias = data.result[i].alias
            obj[alias] = data.result[i].customName
          }
          this.setAliasList(obj)
        })
      },
      submitDelete (checked, type) {
        this.$refs.messageList.deleteBox = false
        if (type === 'true') {
          this.$refs.messageList.submitDelete(checked)
        }
      },
      openDeleteBox () {
        this.$refs.delete.dialogFormVisible = true
        this.$refs.messageList.deleteBox = true
      }
    },

    components: {
      commonheader,
      sidemenu,
      Dycti: (resolve) => {
        require.ensure(['components/common/call-cti'], () => resolve(require('components/common/call-cti')), 'call-cti')
      },
      deleteMessage,
      messageList
    },

    watch: {
      routeChild (val) {
        this.key = val
      }
    }
  }
</script>

<style lang="less" scoped>
.saas-pro-hint {
  position: relative;
  height: 35px;
  line-height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  background-color: #fcf2de;
  .saas-pro-hint-text {
    color: #FF9800;
    font-size: 14px;
  }
  .el-icon-close {
    cursor: pointer;
  }
}
.side-menu-class {
  top: 75px !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?6176b733